import BaseModel from "lib/model";
import Buyers from "collections/buyers";
import Addresses from "collections/addresses";

export default BaseModel.extend({
    props: {
        _id: "objectId",
        __schema_id: { type: "objectId" },
        __name: { type: "string" },
        __code: "string",

        __brand: { type: "object", required: false },
        __warehouse: { type: "objectId", required: false },
        __customer_group: "objectId",
        __pricing_template: "string",
        __merchant_id: { type: "string", required: false },

        __allow_bulk: { type: "boolean", default: false, required: false },
        __active: { type: "boolean", default: true, required: true },

        __discount: { type: "percent", required: false, default: 0 },
        __currency_codes: {
            type: "array",
            required: false,
            default: function () {
                return ["USD"];
            },
        },
        access_control: { type: "number", required: false },
    },
    children: {
        __settings: BaseModel.extend({
            props: {
                __pricing_template: { type: "string" },
                __default_discount: { type: "number" },
                __warehouses: {
                    type: "array",
                    required: true,
                    default: function () {
                        return [];
                    },
                },
                __customer_groups: {
                    type: "array",
                    required: false,
                    default: function () {
                        return [];
                    },
                },
            },
        }),
    },
    collections: {
        __addresses: Addresses,
        __buyers: Buyers,
    },

    derived: {
        _defaultBillingAddress: {
            deps: ["__addresses"],
            fn() {
                return this.getDefaultAddress("billing");
            },
        },
        _defaultShippingAddress: {
            deps: ["__addresses"],
            fn() {
                return this.getDefaultAddress("shipping");
            },
        },
    },

    getDefaultAddress(type) {
        let address = [];

        if (type === "shipping" || type === "billing") {
            address = this.__addresses.filter((addr) => {
                return addr[`default_${type}`];
            });
        } else {
            throw new TypeError("Invalid address type");
        }

        return address[0] || this.__addresses[0] || undefined;
    },

    getBuyersAsContacts: () => {
        this.__buyers.map((buyer) => {
            return {
                company_name: this.__name,
                __name: buyer.__name,
                email: buyer.__email,
            };
        });
    },
});
